import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateCourierSettingsMutationVariables = Types.Exact<{
  input: Types.UpdateCourierSettingsInput;
}>;


export type UpdateCourierSettingsMutation = { __typename?: 'Mutation', UpdateCourierSettings: { __typename?: 'UpdateCourierSettingsPayload', courierSettingsPayload?: { __typename?: 'CourierSettingsPayload', courierId?: number | null, indicative?: string | null, etaInterval?: number | null } | null, errors?: Array<{ __typename?: 'InternalServerUserError', message: string, code: 'InternalServerUserError' } | { __typename?: 'UnknownCourierUserError', message: string, courierId: number, code: 'UnknownCourierUserError' } | { __typename?: 'UserError', message: string, code: 'UserError' } | { __typename?: 'ValidationUserError', message: string, code: 'ValidationUserError' }> | null } };


export const UpdateCourierSettingsDocument = gql`
    mutation UpdateCourierSettings($input: UpdateCourierSettingsInput!) {
  UpdateCourierSettings(input: $input) {
    courierSettingsPayload {
      courierId
      indicative
      etaInterval
    }
    errors {
      code: __typename
      ... on Error {
        message
      }
      ... on UnknownCourierUserError {
        courierId
      }
    }
  }
}
    `;
export type UpdateCourierSettingsMutationFn = Apollo.MutationFunction<UpdateCourierSettingsMutation, UpdateCourierSettingsMutationVariables>;

/**
 * __useUpdateCourierSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCourierSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourierSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourierSettingsMutation, { data, loading, error }] = useUpdateCourierSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCourierSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourierSettingsMutation, UpdateCourierSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourierSettingsMutation, UpdateCourierSettingsMutationVariables>(UpdateCourierSettingsDocument, options);
      }
export type UpdateCourierSettingsMutationHookResult = ReturnType<typeof useUpdateCourierSettingsMutation>;
export type UpdateCourierSettingsMutationResult = Apollo.MutationResult<UpdateCourierSettingsMutation>;
export type UpdateCourierSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCourierSettingsMutation, UpdateCourierSettingsMutationVariables>;